

// WIP
// TODO SPLIT GROUPED TYPES INTO SEPARATE FILES

import { DisplayGrid, Draggable, GridsterConfig, Resizable } from "angular-gridster2";
import { ChartCompilationType, ChartContextType, ChartDataDate, ChartDateType, CultevaChartTypes, Cultivar, Filter, FilterPage, FilterQueryMode, FilterSort, Sample, Site, Status } from "../public_api";
import { CultevaIndexChartTypes } from './report';
import { BarChartConfig, BoxplotChartConfig, BubbleChartConfig, ChartXaxisOption, LineChartConfig, ScatterPlotCongig } from "./Reports/report-charts";
import { BarIndexConfig, IndexDataPoint, RadarIndexConfig } from './Reports/report-indexes';
import { TableCompiledData, TableComponentData, TableDataType, TableDirection } from "./Reports/report-tables";

export enum ReportComponentType {
    TEXT = 'TEXT',
    IMAGE = 'IMAGE',
    CHART = 'CHART',
    INDEX = 'INDEX',
    TABLE = 'TABLE',
    GANTT = 'GANTT',
    MEASUREMENTS = 'MEASUREMENTS',
    CHARACTERISTICS = 'CHARACTERISTICS',
    GENERIC = 'GENERIC',
    UNSET = 'UNSET',
}

export const ReportComponentTitle = {
    'TEXT': 'Text',
    'IMAGE': 'Image',
    'MEASUREMENTS': 'Measurements',
    'CHARACTERISTICS': 'Characteristics',
    'GENERIC': 'Generic',
    'UNSET': 'Unset',
}

/**
 * Data Models
 *
 */

export interface GeneratedReportComponent {
    key: string,
    orgKey: string,
    pageKey?: string,
    reportKey: string,
    type: COMPONENTTYPE,
    options: GeneratedReportOptions,
    filters: GeneratedReportFilters,
    dimentions: Dimentions,
    coordinate: Coordinate,
}

// Type of component to display on Report
export enum COMPONENTTYPE {
    DEFAULT = 'DEFAULT',
    IMAGE = 'IMAGE',
    TEXT = 'TEXT',
    MEASURE = 'MEASURE',
    CHAR = 'CHAR',
    TIMELINE = 'TIMELINE',
    TABLE = 'TABLE',
    SITEMAP = 'SITEMAP',
    STORAGE = 'STORAGE',
    WEATHER = 'WEATHER',
}

export interface Coordinate {
    x: number,
    y: number,
}

// Dimentions of component defined by number of cells it takes up in the x and y axis's
export interface Dimentions {
    width: number,
    height: number,
}

export interface GeneratedReportOptions {
    padding: TRBL,
    margin: TRBL,
    theme: ReportTheme
}

// Defines the colors, font and style of the Report
export interface ReportTheme {
    font: string,
    colorPalette: ColorPalette,
}

export interface GeneratedReportFilters {
    // Query + ModelKeys
}

// Top, Right, Bottom & Left - Used for Padding and Margin
export interface TRBL {
    top: number,
    right: number,
    bottom: number,
    left: number,
}

export interface ColorPalette {
    primary: string,
    secondary: string,
    tertiary: string,
}


//? AFTER REFACTOR

export enum ReportDataContext {
    CULTIVAR = 'CULTIVAR',
    SITE = 'SITE',
    SAMPLE = 'SAMPLE',
    EVALUATION = 'EVALUATION',
    TASTE_SAMPLE = 'TASTE_SAMPLE',
    TASTE_EVAL = 'TASTE_EVAL',
    SAMPLE_IMAGE = 'SAMPLE_IMAGE',
    // values must stay identical to Culteva\ReportComponentOption's DATA_* constants
    ORG_ASSET = 'ORG_ASSET',
    REPORT_ASSET = 'REPORT_ASSET',
    UNKNOWN = 'UNKNOWN',
}

/**
 * One row from report-compiler/images. Flat by design — the picker builds its
 * Cultivar → Sample → Evaluation tree client-side. Labels are pre-formatted server-side
 * by Culteva\Services\SampleImageLabelFormatter; no related models are serialised.
 */
export interface ReportImageOption {
    key: string;
    fileRef: string;
    takenAt: string;
    createdAt: string;
    evalKey: string;
    evalStartDate: string;
    sampleKey: string;
    birthDate: string;
    cultivarKey: string;
    siteKey: string;
    siteName: string;
    siteBlock: string;
    /** Raw sample label — short, for the grouped tiers. `sampleLabel` is the long composed form. */
    sampleShortLabel: string;
    sampleCode: string;
    sampleLabel: string;
    cultivarLabel: string;
    /** Stamped client-side by the picker with the tab that produced it (AD-7) — not returned by the API. */
    context?: ReportDataContext;
    /** Org/report asset tabs only (Epic 2) — the sample tab never populates this. */
    name?: string;
}

/**
 * One page of report-compiler/images — pages snap to evaluation boundaries server-side (an evaluation's
 * photos are never split across two pages), so `images.length` lands close to but rarely exactly the
 * server's page size.
 */
export interface ReportImagePage {
    images: ReportImageOption[];
    page: number;
    totalPages: number;
    hasMore: boolean;
}

/** One page of GET organizations/{org}/report-assets or GET advanced-report/{reportKey}/assets. */
export interface ReportAssetPage {
    assets: ReportAssetOption[];
    page: number;
    totalPages: number;
    hasMore: boolean;
}

/**
 * One row from GET organizations/{org}/report-assets (and, from story 2.4, the report-scoped
 * equivalent) — matches Culteva\ReportAsset::$visible verbatim. Mapped onto ReportImageOption
 * at the loader boundary so the picker's tree/tile machinery never has to know two shapes exist.
 */
export interface ReportAssetOption {
    key: string;
    ownerOrgKey: string;
    reportKey: string | null;
    name: string;
    fileRef: string;
    createdAt: string;
    updatedAt: string;
    deletedAt: string | null;
}

export enum ReportAccess {
    RESTRICTED = 'RESTRICTED',
    ANYONE = 'ANYONE',
}

export const SHARE_KEY_HEADER = 'X-Share-Key';

export interface AdvancedReport {
    key: string;
    label: string;
    description: string;
    ownerOrgKey: string;
    shareKey: string;
    access: ReportAccess;

    filter: ReportDataFilter;
    pages: ReportPage[],
    options: AdvancedReportOption,

    createdAt: string;
    updatedAt: string;
    deletedAt: string;
}

export interface AdvancedReportOption {
    key: string;

    reportKey: string;
    config: ReportOptionConfig;

    createdAt: string;
    updatedAt: string;
    deletedAt: string;
}

/**
 * Generic settings that inherit down the Report → Page → Component cascade.
 * Each tier carries the same optional sub-object; an absent value means "inherit from parent".
 * Typography is the first tenant; future settings (e.g. language) register as new keys here.
 */
export interface InheritableSettings {
    typography?: TypographySettings;
}

// Only font family cascades; components keep their own original sizes and weights.
export interface TypographySettings {
    fontFamily?: string;
}

// Fully-populated typography handed to renderers (no inherited gaps remain).
export interface ResolvedTypography {
    fontFamily: string;
}

export const DEFAULT_TYPOGRAPHY: ResolvedTypography = {
    fontFamily: 'Roboto',
}

// Bundled families (Roboto, Montserrat) are pinned first; the rest load on demand from Google Fonts.
export const FONT_FAMILY_OPTIONS: string[] = [
    'Roboto', 'Montserrat',
    'Open Sans', 'Lato', 'Poppins', 'Inter', 'Nunito', 'Nunito Sans', 'Raleway',
    'Work Sans', 'Mulish', 'Rubik', 'DM Sans', 'Manrope', 'Karla', 'Cabin',
    'Source Sans Pro', 'PT Sans', 'Noto Sans', 'Quicksand', 'Josefin Sans',
    'Oswald', 'Archivo', 'Barlow',
    'Merriweather', 'Playfair Display', 'Lora', 'Libre Baskerville', 'PT Serif',
    'Roboto Slab', 'Roboto Mono', 'Source Code Pro',
];

export interface ReportOptionConfig {
    pageOrientation: PageOrientation;
    isLocked: boolean;
    inherited?: InheritableSettings;
    // Optional so existing reports (no field) resolve to Standard; see resolveGridDensity.
    gridDensity?: GridDensity;
    // Visual-only margin guide, in grid cells; not a placement boundary. See resolveReportMargin.
    margin?: number;
    // Layout-grid visibility (gridster displayGrid); optional so existing reports resolve to While dragging.
    gridVisibility?: DisplayGrid;
}

export const ADVANCED_REPORT_OPTION_DEFAULT: ReportOptionConfig = {
    pageOrientation: 'portrait',
    isLocked: false,
    inherited: { typography: { ...DEFAULT_TYPOGRAPHY } },
    gridDensity: 1,
    margin: 0,
    gridVisibility: DisplayGrid.OnDragAndResize,
}

// Grid cells of inset for the visual margin guide; 0 (or absent) means no guide.
export const GRID_MARGIN_DEFAULT: number = 0;

// Above ~5 cells the guide is impractical, so the value is capped here (control + resolver).
export const GRID_MARGIN_MAX: number = 5;

// Clamps to a whole number of cells in [0, GRID_MARGIN_MAX]; tolerates missing/NaN values.
export function resolveReportMargin(config?: ReportOptionConfig): number {
    const margin = Math.floor(config?.margin ?? GRID_MARGIN_DEFAULT);
    if (!(margin > 0)) return 0;
    return Math.min(margin, GRID_MARGIN_MAX);
}

// Per-report placement-grid scale factor: Standard (25px cells) or Dense (12.5px cells).
export type GridDensity = 1 | 2;

export const GRID_DENSITY_DEFAULT: GridDensity = 1;

// Base gridster cell size in px at Standard density; a denser grid divides this.
export const BASE_CELL_SIZE: number = 25;

// Absent field on existing reports resolves to Standard.
export function resolveGridDensity(config?: ReportOptionConfig): GridDensity {
    return config?.gridDensity ?? GRID_DENSITY_DEFAULT;
}

export const GRID_VISIBILITY_DEFAULT: DisplayGrid = DisplayGrid.OnDragAndResize;

// Absent field on existing reports resolves to While dragging (pre-feature behaviour).
export function resolveGridVisibility(config?: ReportOptionConfig): DisplayGrid {
    return config?.gridVisibility ?? GRID_VISIBILITY_DEFAULT;
}

// Derives a density-scaled gridster config: cell size shrinks by the factor while
// column/row counts grow by it, so a denser grid keeps the same physical page size.
// Identity at density 1, so existing reports render unchanged.
export function scaleGridOptions(grid: GridsterConfig, density: GridDensity): GridsterConfig {
    const factor = density || GRID_DENSITY_DEFAULT;

    const maxCols = scaleCount(grid.maxCols, factor);
    const maxRows = scaleCount(grid.maxRows, factor);

    return {
        ...grid,
        fixedColWidth: BASE_CELL_SIZE / factor,
        fixedRowHeight: BASE_CELL_SIZE / factor,
        maxCols,
        maxItemCols: scaleCount(grid.maxItemCols, factor),
        defaultItemCols: scaleCount(grid.defaultItemCols, factor),
        maxRows,
        maxItemRows: scaleCount(grid.maxItemRows, factor),
        defaultItemRows: scaleCount(grid.defaultItemRows, factor),
        // gridster2 defaults maxItemArea to 2500 and blocks any resize/placement whose cols*rows
        // exceeds it, regardless of free page space. Derived (never persisted) so a component can
        // always be resized up to the full page, at any density. Falls back to gridster's own
        // default rather than an unusable 0/NaN if maxCols/maxRows are ever malformed.
        maxItemArea: Number.isFinite(maxCols) && Number.isFinite(maxRows) && maxCols > 0 && maxRows > 0
            ? maxCols * maxRows
            : 2500,
    };
}

function scaleCount(value: number, factor: GridDensity): number {
    return Number.isFinite(value) ? value * factor : value;
}

// Component placement in grid-cell units; rescaled when a report's density changes.
export interface ComponentGeometry {
    x: number;
    y: number;
    width: number;
    height: number;
}

// ratio = newDensity / oldDensity. Multiplying the cell-unit geometry by it keeps
// the component's physical footprint at the new cell size. Results are floored to whole
// cells (upscale stays exact; downscale rounds down so it always fits) and width/height
// are clamped to a minimum of one cell so a component can never collapse to nothing.
export function scaleComponentGeometry(geometry: ComponentGeometry, ratio: number): ComponentGeometry {
    return {
        x: Math.max(0, Math.floor(geometry.x * ratio)),
        y: Math.max(0, Math.floor(geometry.y * ratio)),
        width: Math.max(1, Math.floor(geometry.width * ratio)),
        height: Math.max(1, Math.floor(geometry.height * ratio)),
    };
}

// Keeps a component's rescaled geometry inside the page's current bounds. Width/height only
// shrink if the component's own size exceeds the new dimensions (rare — e.g. a full-bleed
// component after a big dimension change); x/y then clamp into whatever room remains. A
// geometry already inside bounds is returned unchanged (identity), matching the existing
// scaleComponentGeometry floor/minimum-1-cell convention.
export function clampComponentGeometry(geometry: ComponentGeometry, maxCols: number, maxRows: number): ComponentGeometry {
    const width = Math.max(1, Math.min(geometry.width, maxCols));
    const height = Math.max(1, Math.min(geometry.height, maxRows));
    const x = Math.max(0, Math.min(geometry.x, maxCols - width));
    const y = Math.max(0, Math.min(geometry.y, maxRows - height));
    return { x, y, width, height };
}

// Standard AABB overlap test. Pulled out of ReportComponentView so both it and ReportView (which
// has no existing-component instance to check placement from, for a not-yet-created component) can
// share the same collision math instead of maintaining two implementations.
export function geometryCollides(a: ComponentGeometry, b: ComponentGeometry): boolean {
    return a.x < b.x + b.width
        && a.x + a.width > b.x
        && a.y < b.y + b.height
        && a.y + a.height > b.y;
}

// Searches every valid top-left position for a widthxheight item within maxCols/maxRows, ordered
// nearest-first from (preferredX, preferredY), returning the first that doesn't collide with any
// entry in `siblings` — or null if there's nowhere free (including the defensive case where the
// item's own size doesn't fit the bounds at all). Callers are responsible for pre-filtering
// `siblings` to whatever set actually matters to them (e.g. same-layer only) — this function is
// pure geometry, no store/layer awareness.
export function findFreePosition(siblings: ComponentGeometry[], width: number, height: number, maxCols: number, maxRows: number, preferredX: number, preferredY: number): { x: number, y: number } | null {
    const maxX = maxCols - width;
    const maxY = maxRows - height;
    if (maxX < 0 || maxY < 0) return null;

    const candidates: { x: number, y: number }[] = [];
    for (let y = 0; y <= maxY; y++) {
        for (let x = 0; x <= maxX; x++) {
            candidates.push({ x, y });
        }
    }

    candidates.sort((a, b) => {
        const da = (a.x - preferredX) ** 2 + (a.y - preferredY) ** 2;
        const db = (b.x - preferredX) ** 2 + (b.y - preferredY) ** 2;
        return da - db;
    });

    return candidates.find(candidate =>
        !siblings.some(sibling => geometryCollides({ ...candidate, width, height }, sibling))
    ) ?? null;
}

export type NewReportOption = Omit<AdvancedReportOption, 'key'| 'createdAt' | 'updatedAt' | 'deletedAt'>;

export interface ReportDataFilter {
    page: FilterPage;
    sort: FilterSort;
    queries: {k: string, v: string, m: FilterQueryMode}[];
}

export interface ReportFilterOptions {
    ownerOrgKey: string;
    search: string
    scionCropId: string[];
    scionCultivarKey: string[];
    siteKey: string[];
    birthWeek: number[];
    birthYear: number[];
    seasonMonth: number | null;
    seasonYear: number[];
    licensee: string[];
}

export interface AdvancedReportData {
    samples: Sample[];
}

export interface ReportPage {
    key: string;

    reportKey: string;
    filter: ReportDataFilter;
    index: number;

    report: AdvancedReport;
    options: ReportPageOption;
    components: BaseReportComponent[];

    createdAt: string;
    updatedAt: string;
    deletedAt: string;
}

export interface ReportPageOption {
    key: string;

    pageKey: string;
    config: PageOptionConfig;

    createdAt: string;
    updatedAt: string;
    deletedAt: string;
}

export type NewPageOption = Omit<ReportPageOption, 'key'| 'createdAt' | 'updatedAt' | 'deletedAt'>;

export type PageOrientation = "portrait" | "landscape";

export const PageLongEdge: number = 44;
export const PageShortEdge: number = 31;

export interface PageOptionConfig {
    //? GRIDSTER CONFIG OPTIONS
    gridOptions: CultevaGridsterConfig;

    //? GENERAL PAGE OPTIONS
    // Flat, intentionally NOT part of the inheritable cascade: a landscape page in a portrait report
    // is a deliberate per-page choice, not a fallback. Cascading settings live in `inherited` below.
    pageOrientation: PageOrientation;

    inherited?: InheritableSettings;
}

export interface CultevaGridsterConfig {
    //* GRID OPTIONS
    displayGrid: DisplayGrid;
    swap: boolean;
    draggable: Draggable;
    resizable: Resizable;

    //* COLUMN OPTIONS
    fixedColWidth: number;
    minCols: number;
    maxCols: number;
    minItemCols: number;
    maxItemCols: number;
    defaultItemCols: number;

    //* ROW OPTIONS
    fixedRowHeight: number;
    minRows: number;
    maxRows: number;
    minItemRows: number;
    maxItemRows: number;
    defaultItemRows: number;

    //* LAYERING OPTIONS
    allowMultiLayer: boolean;

    //* SCROLL OPTIONS
    disableScrollVertical: true,
    disableScrollHorizontal: true,
}

export const PAGE_OPTION_DEFAULT: PageOptionConfig = {
    gridOptions: {
        displayGrid: DisplayGrid.OnDragAndResize,
        swap: true,
        draggable: {
            enabled: true,
        },
        resizable: {
            enabled: true,
        },
        fixedColWidth: 25, // TODO SHOULD THIS BE DYNAMIC
        minCols: 1,
        maxCols: PageShortEdge,
        minItemCols: 2,
        maxItemCols: PageShortEdge,
        defaultItemCols: PageShortEdge,
        fixedRowHeight: 25, // TODO SHOULD THIS BE DYNAMIC
        minRows: 1,
        maxRows: PageLongEdge,
        minItemRows: 2,
        maxItemRows: PageLongEdge,
        defaultItemRows: PageLongEdge,
        allowMultiLayer: true,
        disableScrollVertical: true,
        disableScrollHorizontal: true,
    },
    pageOrientation: "portrait",
    inherited: {},
}

export const PORTRAIT_PAGE_OPTIONS: Partial<CultevaGridsterConfig> = {
    maxCols: PageShortEdge,
    maxItemCols: PageShortEdge,
    defaultItemCols: PageShortEdge,
    maxRows: PageLongEdge,
    maxItemRows: PageLongEdge,
    defaultItemRows: PageLongEdge,
}

export const LANDSCAPE_PAGE_OPTIONS: Partial<CultevaGridsterConfig> = {
    maxCols: PageLongEdge,
    maxItemCols: PageLongEdge,
    defaultItemCols: PageLongEdge,
    maxRows: PageShortEdge,
    maxItemRows: PageShortEdge,
    defaultItemRows: PageShortEdge,
}

export interface TextComponentData {
    content: string;
}

export interface ImageComponentData {
    fileRef: string;
    context: ReportDataContext;
    dataKey: string;
}

// TODO REFACTOR NAME TO MEASURES
export interface MeasureChartComponentData {
    label: string;
    chartTitle: string;
    type: keyof CultevaChartTypes;
    showLegend: boolean;
    context: ChartContextType;
    measure: string;
    secondaryMeasure: string;
    tertiaryMeasure: string;
    xAxis: ChartXaxisOption;
    dateFormat: ChartDateType;
    dataDate: ChartDataDate;
    compilationType: ChartCompilationType;
    chartConfig: BarChartConfig | LineChartConfig | BoxplotChartConfig | ScatterPlotCongig | BubbleChartConfig; // TODO CHART CONFIG OPTIONS
}

export interface IndexComponentData {
    label: string;
    type: keyof CultevaIndexChartTypes;
    showLegend: boolean;
    context: ChartContextType;
    dataPoints: IndexDataPoint[];
    indexConfig: BarIndexConfig | RadarIndexConfig;
}

export type GanttSortMode = 'earliest' | 'latest';
export type GanttScale    = 'week';
export type GanttContext  = 'CULTIVAR' | 'SITE' | 'SAMPLE' | 'EVALUATION';
export type GanttViewMode = 'zoomed' | 'full';
/** Axis start week: 1 = calendar (W01–W53), 27 = split year (W27–W26) for seasons that cross the new year. */
export type GanttAxisStart = 1 | 27;

export interface GanttComponentData {
    /** Up to 2 EVENT-type characteristic IDs */
    charIds:  string[];
    /** ISO week scale W01-W52 */
    scale:    GanttScale;
    /** Sort rows ascending (earliest) or descending (latest) */
    sortMode: GanttSortMode;
    /** Context determines Y-axis grouping */
    context:  GanttContext;
    /** Axis range: 'zoomed' = data range + buffer (default); 'full' = always W01-W53.
     *  Optional for back-compat with components saved before this field existed. */
    viewMode?: GanttViewMode;
    /** Axis start week (1 or 27). Drives server-side rotation, so changing it recompiles. Optional/back-compat. */
    axisStartWeek?: GanttAxisStart;
    /** Optional chart title rendered top-centre. Blank/undefined hides it. */
    title?:    string;
}

export interface GanttCompiledData {
    datasets: GanttDataset[];
    labels:   string[];
    axisMin:  number;    // padded min (rotated) week slot
    axisMax:  number;    // padded max (rotated) week slot
    /** Axis start the server rotated against; the client reverse-maps slot→week for labels. */
    axisStartWeek?: GanttAxisStart;
}

export interface GanttDataset {
    label:           string;
    /** Per-row bar in rotated slot coords; null for a suppressed row. Index-aligned with `labels`. */
    data:            ([number, number] | null)[];
    backgroundColor: string[];
    borderColor:     string[];
    borderWidth:     number;
    borderRadius:    number;
    charLabels:      string[][];
    /** Per-row: span wraps the chosen axis start (suppressed; switching the axis fixes it). */
    wrapsAxis?:      boolean[];
    /** Per-row: aggregates multiple seasons (suppressed on every axis). */
    multiSeason?:    boolean[];
}

export const GANTT_OPTION_DEFAULT: GanttComponentData = {
    charIds:       [],
    scale:         'week',
    sortMode:      'earliest',
    context:       'CULTIVAR',
    viewMode:      'zoomed',
    axisStartWeek: 1,
    title:         '',
};

export interface ReportComponent<T> {
    key: string;

    pageKey: string;
    filter: ReportDataFilter;
    type: ReportComponentType;
    width: number;
    height: number;
    x: number;
    y: number;

    page: ReportPage;
    options: ReportComponentOption<T>;

    createdAt: string;
    updatedAt: string;
    deletedAt: string;
}

export interface ReportComponentOption<T> {
    key: string;
    componentKey: string;

    data: T;
    config: ComponentConfigOption;

    createdAt: string;
    updatedAt: string;
    deletedAt: string;
}

export interface TextComponent extends ReportComponent<TextComponentData> {
    type: ReportComponentType.TEXT;
}

export interface ImageComponent extends ReportComponent<ImageComponentData> {
    type: ReportComponentType.IMAGE;
}

export interface ChartComponent extends ReportComponent<MeasureChartComponentData> {
    type: ReportComponentType.CHART;
}

export interface IndexComponent extends ReportComponent<IndexComponentData> {
    type: ReportComponentType.INDEX;
}

export interface TableComponent extends ReportComponent<TableComponentData> {
    type: ReportComponentType.TABLE;
}

export interface GanttComponent extends ReportComponent<GanttComponentData> {
    type: ReportComponentType.GANTT;
}

export type BaseReportComponent = TextComponent | ImageComponent | ChartComponent | IndexComponent | TableComponent | GanttComponent;

export type AnyComponentOption =
    | ReportComponentOption<TextComponentData>
    | ReportComponentOption<ImageComponentData>
    | ReportComponentOption<MeasureChartComponentData>
    | ReportComponentOption<IndexComponentData>
    | ReportComponentOption<TableComponentData>
    | ReportComponentOption<GanttComponentData>;

export type NewComponentOption<T> = Omit<ReportComponentOption<T>, 'key'| 'createdAt' | 'updatedAt' | 'deletedAt'>

// TODO ADD MORE TYPES AS NEEDED
export type AnyReportComponentData = TextComponentData | ImageComponentData | MeasureChartComponentData | IndexComponentData | TableComponentData | GanttComponentData;

export interface TextCompiledData {
    //? NEEDED FOR VARIABLES
    variableMap: null;
}


export interface ChartCompiledData {
    datasets: any[], //? check if it makes sense to define dataset types for each chart type
    labels: string[],
}

export type AnyCompiledComponentData =
    | ChartCompiledData
    | TextCompiledData
    | TableCompiledData
    | GanttCompiledData
    | null;

export interface CompiledOptionResult {
    option: AnyComponentOption,
    compiled: AnyCompiledComponentData,
}

export const TEXT_OPTION_DEFAULT: TextComponentData = {
    content: null,
}

export const IMAGE_OPTION_DEFAULT: ImageComponentData = {
    context: ReportDataContext.UNKNOWN,
    dataKey: null,
    fileRef: null,
}

export const CHART_OPTION_DEFAULT: MeasureChartComponentData = {
    type: null,
    chartTitle: null,
    showLegend: true,
    context: null,
    measure: null,
    secondaryMeasure: null,
    tertiaryMeasure: null,
    xAxis: null,
    compilationType: null,
    dataDate: null,
    dateFormat: null,
    label: null,
    chartConfig: null,
}

export const INDEX_OPTION_DEFAULT: IndexComponentData = {
    context: null,
    dataPoints: null,
    indexConfig: null,
    label: null,
    showLegend: true,
    type: null,
}

export interface ComponentConfigOption {
    layerIndex: number;
    radius: number;
    fillArea: boolean;
    focalX?: number;
    focalY?: number;
    zoom?: number;
    inherited?: InheritableSettings;
}

// Shared between report-page.view.ts's gridster recovery callback and report-component.view.ts's
// duplication room-check and layer-switch collision block — all describe the same underlying
// condition (a component's position colliding with a same-layer sibling), so they show the
// identical message.
export const COMPONENT_OVERLAP_WARNING = "A component may be overlapping another on this page — please review its position.";

// Shown when a layer switch is auto-nudged to a different position rather than blocked — the user
// didn't ask for the component to move, so this explains why it did.
export const COMPONENT_LAYER_SWITCH_MOVED_NOTICE = "Component moved to avoid overlapping another component on this layer.";

export const COMPONENT_CONFIG_DEFAULT: ComponentConfigOption = {
    layerIndex: 1,
    radius: 0,
    fillArea: true,
    focalX: 0.5,
    focalY: 0.5,
    zoom: 1,
    inherited: {},
}

export interface ImageFocalPoint {
    focalX: number;
    focalY: number;
    zoom: number;
}

// Absent fields (every existing image) resolve to center / zoom 1 — visually identical to today's
// centered object-fit: cover crop. Out-of-range stored values are clamped rather than propagated.
export function resolveImageFocalPoint(config?: ComponentConfigOption): ImageFocalPoint {
    const clamp = (value: number, min: number, max: number) => Math.min(max, Math.max(min, value));
    return {
        focalX: clamp(config?.focalX ?? 0.5, 0, 1),
        focalY: clamp(config?.focalY ?? 0.5, 0, 1),
        zoom: clamp(config?.zoom ?? 1, 1, 3),
    };
}

export interface GenericReportTemplate<T> {
    key: string;
    ownerOrgKey: string;
    label: string;
    description: string;
    isGlobal: boolean;

    data: T;
    type: ReportTemplateTypes;

    createdAt: string;
    updatedAt: string;
    deletedAt: string;
}

export enum ReportTemplateTypes {
    REPORT = "REPORT",
    PAGE = "PAGE",
}

export interface AdvancedReportTemplate extends GenericReportTemplate<AdvancedReportTemplateData> {
    type: ReportTemplateTypes.REPORT;
}

export interface ReportPageTemplate extends GenericReportTemplate<PageTemplateData> {
    type: ReportTemplateTypes.PAGE;
}

export type NewReportTemplate<T> = Omit<T, 'key'| 'createdAt' | 'updatedAt' | 'deletedAt'>;

export type AnyReportTemplate =
    | AdvancedReportTemplate
    | ReportPageTemplate;

export interface AdvancedReportTemplateData {
    config: ReportOptionConfig;
    pages: PageTemplateData[];
}

export interface PageTemplateData {
    index: number;
    config: PageOptionConfig;
    components: ComponentTemplateData[]
}

export interface BaseComponentTemplateData {
    type: ReportComponentType;
    width: number;
    height: number;
    x: number;
    y: number;
    config: ComponentConfigOption,
}

export interface TextComponentTemplateData extends BaseComponentTemplateData {
    type: ReportComponentType.TEXT;
    data: TextComponentData;
}

export interface ImageComponentTemplateData extends BaseComponentTemplateData {
    type: ReportComponentType.IMAGE;
    data: ImageComponentData;
}

export interface MeasureChartComponentTemplateData extends BaseComponentTemplateData {
    type: ReportComponentType.CHART;
    data: MeasureChartComponentData
}

export interface IndexComponentTemplateData extends BaseComponentTemplateData {
    type: ReportComponentType.INDEX;
    data: IndexComponentData
}

export interface TableComponentTemplateData extends BaseComponentTemplateData {
    type: ReportComponentType.TABLE;
    data: TableComponentData
}

export type ComponentTemplateData = TextComponentTemplateData
    | ImageComponentTemplateData
    | MeasureChartComponentTemplateData
    | IndexComponentTemplateData
    | TableComponentTemplateData;
